//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
//Action types
import {
    LASTREADING_REQUEST_DETAILS_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    lastReadingRequestDetailsResult,
} from 'Redux/actions';
function* getGadgetData({ payload }) {
    try {
        let QUERY = `
            query getGadgetData ($id: String!, $query: GadgetDataQuery) {
                result: getGadgetData (id: $id, query: $query)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload.data,
            endpoints.GRAPHQL_GENERAL,
        );
        let result = null
        try {
            result = data?.result && typeof data?.result === 'string' ? JSON.parse(data?.result) : null
        } catch (error) { }

        if (result?.items?.length) {
            yield put(lastReadingRequestDetailsResult(result?.items))
        } else yield put(lastReadingRequestDetailsResult([]))

    } catch (exc) {
        yield put(lastReadingRequestDetailsResult([]))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/lastReadingDetails/redux/saga', 'getGadgetData');
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(LASTREADING_REQUEST_DETAILS_REQUEST, getGadgetData);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}